import React, { useState } from 'react'
import { Flex, Icon, Text, Box } from '@clear/design-system'
import { Modal } from '@components/shared/Modal'

interface GeoLocateProps {
  onSuccessHandler: (position: GeolocationPosition) => void
  onErrorHandler?: (error?: GeolocationPositionError) => void
  linkText?: string
}

export function GeoLocate({
  onSuccessHandler,
  onErrorHandler,
  linkText = 'Use my location with Google Maps',
}: GeoLocateProps) {
  const [status, setStatus] = useState('')
  const [showModal, setShowModal] = useState(false)
  const geoLocateErrorHandler = (error: GeolocationPositionError) => {
    setShowModal(true)
    onErrorHandler && onErrorHandler(error)
  }

  function doGeoLocate() {
    if (!navigator.geolocation) {
      setStatus('Geolocation is not supported by your browser')
    } else {
      navigator.geolocation.getCurrentPosition(
        onSuccessHandler,
        geoLocateErrorHandler
      )
    }
  }

  return (
    <Flex
      mx={[null, 4]}
      width={['full', '65%']}
      height="100%"
      justifyContent="center"
      alignItems="center"
    >
      <Box
        as="button"
        id="geo-locate"
        data-cy="geo-locate-button"
        textAlign="center"
        color="brandDarkBlue"
        border="none"
        backgroundColor="utilityTransparent"
        sx={{
          cursor: 'pointer',
        }}
        onClick={doGeoLocate}
      >
        <Flex alignItems="center">
          <Icon name="navigation" color="brandDarkBlue" />
          <Text variant="display" ml={2} className="underline">
            {linkText}
          </Text>
        </Flex>
      </Box>
      {status && <Text>{status}</Text>}
      <Modal
        showModal={showModal}
        setShowModal={setShowModal}
        header="We couldn’t access your location"
        body="Turn on location sharing or use the search bar to find the closest enrollment location near you."
        successButtonText="OK"
        successLink=""
        successClick={() => setShowModal(false)}
        canClose={true}
      />
    </Flex>
  )
}
